<div class="task-notifications">
  <p class="hint">{{ hint }}</p>

  <div class="settings-error" *ngIf="error()">{{ error() }}</div>

  <ul class="recipients" *ngIf="rows().length > 0">
    <li class="recipient" *ngFor="let recipient of rows()" [class.recipient-unassigned]="recipient.unassigned">
      <app-svg-icon
        *ngIf="recipient.departmentId != null; else personAvatar"
        icon="user-multiple"
        [size]="32"
        color="var(--color-primary)"
      ></app-svg-icon>
      <ng-template #personAvatar>
        <app-user-avatar [userEmail]="recipient.userEmail ?? ''" [size]="32"></app-user-avatar>
      </ng-template>

      <div class="recipient-text">
        <span class="recipient-name">{{ recipient.displayName }}</span>
        <span class="recipient-role" *ngIf="recipient.roleName">{{ recipient.roleName }}</span>
        <span class="recipient-role recipient-projects" *ngIf="recipient.projectNames">{{ recipient.projectNames }}</span>
        <span class="recipient-role" *ngIf="recipient.unassigned">{{ unassignedLabel }}</span>
      </div>

      <button
        type="button"
        class="recipient-remove"
        *ngIf="recipient.removable"
        [disabled]="saving()"
        i18n-title="@@remove"
        title="Remove"
        (click)="remove(recipient)"
      >
        <app-svg-icon icon="delete" [size]="18" color="#c0392b"></app-svg-icon>
      </button>
    </li>
  </ul>

  <dx-select-box
    #picker
    class="gpd-input recipient-picker"
    [dataSource]="selectableUsers()"
    displayExpr="displayName"
    valueExpr="emailAddress"
    [searchEnabled]="true"
    searchMode="contains"
    searchExpr="displayName"
    [showClearButton]="false"
    [disabled]="saving() || loading()"
    [placeholder]="placeholder"
    itemTemplate="personTemplate"
    (onSelectionChanged)="onPersonSelected($safeNavigationMigration($event.selectedItem?.emailAddress), picker)"
  >
    <div *dxTemplate="let person of 'personTemplate'">
      <div class="person-item">
        <app-user-avatar [userEmail]="person.emailAddress" [size]="24"></app-user-avatar>
        <span class="person-name">{{ person.displayName }}</span>
      </div>
    </div>
  </dx-select-box>
</div>
